import { useMsal } from '@azure/msal-react';
import { useIsAuthenticated } from '@azure/msal-react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { isAuthConfigured, loginRequest } from '@/auth/config';
import { takeReturnTo } from '@/auth/AuthProvider';

export function SignIn() {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { t } = useTranslation();

  if (isAuthenticated) {
    return <Navigate to={takeReturnTo() ?? '/'} replace />;
  }

  return (
    <section className="mx-auto max-w-sm space-y-6 pt-16 text-center">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight text-[var(--color-primary)]">
          MainLine Pro
        </h1>
        <p className="mt-2 text-sm text-[var(--color-muted-foreground)]">{t('signIn.tagline')}</p>
      </div>

      {isAuthConfigured ? (
        <Button className="w-full" onClick={() => void instance.loginRedirect(loginRequest)}>
          {t('signIn.signIn')}
        </Button>
      ) : (
        <p className="rounded-md border p-3 text-sm text-[var(--color-muted-foreground)]">
          {t('signIn.notConfigured')}
        </p>
      )}

      {/* Accounts are provisioned with a subscription rather than self-service;
          see docs/identity.md. Self-service sign-up lands with M2 onboarding. */}
      <p className="text-xs text-[var(--color-muted-foreground)]">
        {t('signIn.needAccount')}{' '}
        <a className="underline" href="https://mainlinepro.net/waitlist">
          {t('signIn.getStarted')}
        </a>
      </p>
    </section>
  );
}
